<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Formularios y TPSNS</h4>
    <hr />

    <DataTable
      :data="elemexams"
      :columns="columnas"
      idField="idElemExam"
      mensajeVacio="No hay registros de formularios TPSNS."
      :mostrarBotonNuevo="esAdmin"
      :mostrarEditar="esAdmin"
      :mostrarVer="false"
      :mostrarEliminar="esAdmin"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idElemExam)"
      @delete="row => deleteElemExam(row.idElemExam)"
    >
      <!-- Búsqueda por nombre en la barra de acciones -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar nombre formulario..."
            style="width:240px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">

              <!-- ── Buscador Examen ──────────────────────────────── -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Examen</label>
                  </div>
                  <div class="col-10" style="position:relative">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchTextExamen"
                      @input="filterExamens"
                      @focus="showDropdownExamen = true"
                      @blur="hideDropdown('Examen')"
                      placeholder="Buscar examen..."
                    />
                    <ul
                      v-if="showDropdownExamen && filteredExamens.length"
                      class="dropdown-menu shadow show"
                      style="max-height:250px; overflow-y:auto; width:100%; position:absolute; z-index:1055"
                    >
                      <li
                        v-for="examen in filteredExamens"
                        :key="examen.idExamen"
                      >
                        <a
                          class="dropdown-item"
                          href="#"
                          @mousedown.prevent="selectExamen(examen)"
                        >
                          {{ examen.nombre }}
                        </a>
                      </li>
                    </ul>
                    <div class="form-text text-muted" v-if="datoElemExam.idExamen">
                      <span class="badge bg-success">
                        <span class="material-icons" style="font-size:12px;vertical-align:middle">check</span>
                        Seleccionado: {{ searchTextExamen }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ── Buscador Elemento TPSNS ─────────────────────── -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Elemento TPSNS</label>
                  </div>
                  <div class="col-10" style="position:relative">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchTextElemento"
                      @input="filterElementos"
                      @focus="showDropdownElemento = true"
                      @blur="hideDropdown('Elemento')"
                      placeholder="Buscar elemento..."
                    />
                    <ul
                      v-if="showDropdownElemento && filteredElementos.length"
                      class="dropdown-menu shadow show"
                      style="max-height:250px; overflow-y:auto; width:100%; position:absolute; z-index:1055"
                    >
                      <li
                        v-for="elemento in filteredElementos"
                        :key="elemento.idElemento"
                      >
                        <a
                          class="dropdown-item"
                          href="#"
                          @mousedown.prevent="selectElemento(elemento)"
                        >
                          {{ elemento.codigo }} — {{ elemento.nombre }}
                        </a>
                      </li>
                    </ul>
                    <div class="form-text text-muted" v-if="datoElemExam.idElemento">
                      <span class="badge bg-success">
                        <span class="material-icons" style="font-size:12px;vertical-align:middle">check</span>
                        Seleccionado: {{ searchTextElemento }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarElemExam"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarElemExam"
              v-if=" btnEditar && esAdmin "
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "ElemExamList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      elemexams:    [],
      datoElemExam: {},
      nombreBusqueda: "",
      titulo:       "",
      btnCrear:     false,
      btnEditar:    false,
      modalWindow:  true,
      idPerfil:     0,

      // Listas auxiliares
      elementos:     [],
      examens:       [],

      // Buscador Elemento
      searchTextElemento:   "",
      filteredElementos:    [],
      showDropdownElemento: false,

      // Buscador Examen
      searchTextExamen:   "",
      filteredExamens:    [],
      showDropdownExamen: false,
    };
  },

  computed: {
    esAdmin() {
      return Number(this.idPerfil) === 1;
    },

    columnas() {
      return [
        { label: "Nombre en Formulario", field: "examenNombre"   },
        { label: "Código TPSNS",         field: "elementoCodigo" },
        { label: "Nombre TPSNS",         field: "elementoNombre" },
      ];
    },
  },

  mounted() {
    this.idPerfil = window.sessionStorage.getItem("idPerfil");
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
    this.fetchElementos();
    this.fetchExamens();
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwelemexams")
        .then(r => { this.elemexams = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar elemexams:", e));
    },

    // El endpoint original no tenía búsqueda por nombre, se filtra en frontend
    getDataNombre() {
      const texto = this.nombreBusqueda.trim().toLowerCase();
      if (!texto) { this.getData(); return; }
      api.get("/vwelemexams")
        .then(r => {
          this.elemexams = (r.data ?? []).filter(e =>
            (e.examenNombre ?? "").toLowerCase().includes(texto)
          );
        })
        .catch(e => console.error("Error al buscar:", e));
    },

    // ── Fetch auxiliares ──────────────────────────────────────
    async fetchElementos() {
      try {
        const r        = await api.get("/vwelementos/idclaselem/2");
        this.elementos = r.data;
      } catch (e) {
        console.error("Error fetching elementos:", e.response?.data || e.message);
      }
    },

    async fetchExamens() {
      try {
        const r      = await api.get("/vwexamens");
        this.examens = r.data;
      } catch (e) {
        console.error("Error fetching examens:", e.response?.data || e.message);
      }
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoElemExam,
        ["idElemento", "idExamen"],
        ["Elemento TPSNS", "Examen"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarElemExam() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/elemexams", this.datoElemExam);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Registro creado exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarElemExam() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/elemexams", this.datoElemExam);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Registro actualizado exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteElemExam(idElemExam) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar registro?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/elemexams/" + idElemExam);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow      = true;
      this.datoElemExam     = {};
      this.titulo           = "Crear Formulario TPSNS";
      this.btnCrear         = true;
      this.btnEditar        = false;
      this.searchTextElemento = "";
      this.searchTextExamen   = "";
      this.filteredElementos  = [];
      this.filteredExamens    = [];
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idElemExam) {
      this.modalWindow = true;
      this.titulo      = "Editar Formulario TPSNS";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp        = await api.get("/vwelemexams/" + idElemExam);
        this.datoElemExam = resp.data;
        this.searchTextElemento =
          (this.datoElemExam.elementoCodigo ?? "") +
          " — " +
          (this.datoElemExam.elementoNombre ?? "");
        this.searchTextExamen = this.datoElemExam.examenNombre ?? "";
      } catch (e) {
        console.error("Error al cargar elemexam:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    // ── Dropdowns ─────────────────────────────────────────────
    hideDropdown(type) {
      setTimeout(() => {
        if (type === "Elemento") this.showDropdownElemento = false;
        if (type === "Examen")   this.showDropdownExamen   = false;
      }, 200);
    },

    filterElementos() {
      const texto = this.searchTextElemento.toLowerCase();
      this.filteredElementos = this.elementos.filter(e =>
        (e.nombre ?? "").toLowerCase().includes(texto) ||
        (e.codigo ?? "").toLowerCase().includes(texto)
      );
    },

    selectElemento(elemento) {
      this.datoElemExam.idElemento = elemento.idElemento;
      this.searchTextElemento      = elemento.codigo + " — " + elemento.nombre;
      this.showDropdownElemento    = false;
      this.filteredElementos       = [];
    },

    filterExamens() {
      const texto = this.searchTextExamen.toLowerCase();
      this.filteredExamens = this.examens.filter(e =>
        (e.nombre ?? "").toLowerCase().includes(texto)
      );
    },

    selectExamen(examen) {
      this.datoElemExam.idExamen = examen.idExamen;
      this.searchTextExamen      = examen.nombre;
      this.showDropdownExamen    = false;
      this.filteredExamens       = [];
    },
  },
};
</script>

<style scoped>
.dropdown-menu.show { display: block; }
</style>